<template>
  <div
    class="animated-spinner-container"
    v-bind:style="{ backgroundImage: 'url(' + eventSettings.backgroundUrl + ')' }"
  >
    <div class="spin-action">
      <h2
        class="prize-name"
        :style="{ opacity: visibility.prize_name !== '0' ? 1 : 0 }"
      >{{this.prizeInfo.name}}</h2>
      <h4 class="winner-indicator" :style="{ opacity: visibility.winner_pos !== '0' ? 1 : 0 }">
        Winner {{current_winner}}
        of {{total_winners}}
      </h4>
      <div class="animated-spinner">
        <div class="lights horizontal top">
          <img src="@/assets/images/lights_horizontal.svg">
        </div>
        <div class="lights horizontal bottom">
          <img src="@/assets/images/lights_horizontal.svg">
        </div>
        <div class="lights vertical left">
          <img src="@/assets/images/lights_vertical.svg">
        </div>
        <div class="lights vertical right">
          <img src="@/assets/images/lights_vertical.svg">
        </div>
        <div class="text-container">
          <div class="dummy transparent" v-if="state=='spin'">0000000000</div>
          <div class="dummy" v-if="state=='spinning'">0000000000</div>
          <div v-show="state=='result'" class="animated-text"/>
        </div>
      </div>
      <div :class="actionBtnClass" v-show="visibility.spin_btns !== '0'">
        <button
          v-if="this.state == 'result'"
          :class="buttonDefault"
          :style="{color: btn_default_color}"
          @click="toggleRejectMenu()"
        >
          <span>{{secondary_action}}</span>
          <div v-if="this.state == 'result' && this.showRejectMenu" class="reject-options">
            <button
              @click="performSecondaryAction('respin')"
              class="dropdown-item respin"
              type="button"
            >Reject and respin</button>
            <button
              @click="performSecondaryAction('moveon')"
              class="dropdown-item move-on"
              type="button"
            >Reject and move on</button>
          </div>
        </button>
        <button
          v-else
          :class="buttonDefault"
          @click="performSecondaryAction('skip')"
          :style="{color: btn_default_color}"
        >
          <FullLoader :loading="createLoading"/>
          {{secondary_action}}
        </button>
        
        <button
          :class="buttonPrimary"
          :style="{color: btn_primary_color}"
          :disabled="disabled_confirm_button"
          @click="performPrimaryAction()"
        >{{primary_action}}</button>
      </div>
    </div>
    <div id="finishModal" class="modal fade" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-body">
            <div class="title">
              <h2>Attention!</h2>
            </div>
            <p class="cancel-warning">
              There are no more attendees on whom to perform the draw. You can either finish this draw
              (all remaining winners will be blank) or cancel the draw (all previous winners info will be discarded).
            </p>
            <div class="modal-btn-container">
              <button class="btn btn-default spin" @click="cancelDraw()">Cancel the draw</button>
              <button class="btn btn-primary" @click="finishDraw()">Finish the draw</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <audio id="myAudio">
      <source src="@/assets/sounds/spinning.mp3" type="audio/mpeg">
      <!-- <source src="horse.mp3" type="audio/mpeg">
      Your browser does not support the audio element.-->
    </audio>
  </div>
</template>

<script>
import FullLoader from "@/components/FullLoader";
import * as odoo from "@/ext/spin";
import axios from "axios";
var $ = require("jquery");
export default {
  name: "AnimatedSpin",
  components: { FullLoader },
  data() {
    return {
      current_winner: 1,
      total_winners: 3,
      state: "spin",
      winner_animate: false,
      btn_default_color: "#fff",
      btn_primary_color: "#fff",
      showRejectMenu: false,
      disabled_confirm_button: false,
      createLoading: false,
      rejectReason: "",
      visibility: {
        prize_name: "0",
        winner_pos: "0",
        spin_btns: "0"
      },
      eventSettings: {
        backgroundUrl: "",
        spinningField: ""
      },
      selected_attendee: {}
    };
  },
  props: ["prizeInfo"],
  created() {
    window.addEventListener(
      "keydown",
      e => {
        switch (e.code) {
          case "Escape":
            this.cancelDraw();
            break;
          case "KeyA":
            this.performSecondaryAction("skip");
            break;
          case "Space":
            if (this.state === "spin") {
              this.startSpin();
            }
            break;
          case "KeyS":
            this.performSecondaryAction("respin");
            break;
          case "KeyD":
            this.performSecondaryAction("moveon");
            break;
          case "KeyC":
            this.confirmWinner();
            break;
          default:
            break;
        }
      },
      false
    );
    Event.$on("animation ended", function() {
      var nas_mp3 = document.getElementById("myAudio");
      nas_mp3.loop = false;
    });
  },
  destroyed() {
    window.removeEventListener("keydown", () => {}, false);
  },
  async mounted() {
    this.total_winners = this.prizeInfo.winnerCount;
    $(document).mouseup(
      function(e) {
        var container = $(".reject-options");

        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) {
          this.showRejectMenu = false;
        }
      }.bind(this)
    );
    try {
      let getEventSettings = await axios.post(window.ENDPOINT, {
        query: `query {
                  eventSettings(eventId: "${localStorage.getItem(
                    "event_id"
                  )}") {
                    id
                    eventId
                    spinningField
                    backgroundUrl
                    thankyouImageUrl
                    visibility
                    createdAt
                    updatedAt
                  }
                }`
      });
      if (getEventSettings) {
        Object.assign(
          this.eventSettings,
          getEventSettings.data.data.eventSettings
        );
        var visibility = this.eventSettings.visibility.split("");
        Object.assign(this.visibility, {
          prize_name: visibility[0],
          winner_pos: visibility[1],
          spin_btns: visibility[2]
        });
      }
    } catch (error) {
      console.log(error);
    }
  },
  computed: {
    actionBtnClass() {
      return this.winner_animate
        ? "action-btn-container winner-reset-btn"
        : "action-btn-container";
    },
    buttonDefault() {
      return this.state == "spinning"
        ? "btn btn-default draw-action spin dropdown-toggle disabled"
        : "btn btn-default draw-action spin dropdown-toggle";
    },
    buttonPrimary() {
      return this.state == "spinning"
        ? "btn btn-primary spin draw-action disabled"
        : "btn btn-primary draw-action spin";
    },
    primary_action() {
      switch (this.state) {
        case "spin":
        case "respin":
          return "Spin";
          break;
        case "spinning":
          return "Spin";
          break;
        case "result":
          return this.current_winner < this.total_winners
            ? "Confirm"
            : "Confirm and save the draw";
          break;
        default:
          return "Spin";
          break;
      }
    },
    secondary_action() {
      switch (this.state) {
        case "spin":
        case "respin":
          return "Skip";
          break;
        case "spinning":
          return "Skip";
          break;
        case "result":
          return "Reject";
          break;

        default:
          break;
      }
    }
  },
  methods: {
    toggleRejectMenu() {
      this.showRejectMenu = !this.showRejectMenu;
    },

    dummySpinText() {
      var dummy = "";
      var textToSpin = "";
      if (this.eventSettings.spinningField === "name") {
        textToSpin = `${this.selected_attendee.firstname} ${
          this.selected_attendee.lastname
        }`;
      } else {
        textToSpin = `${
          this.selected_attendee[this.eventSettings.spinningField]
        }`;
      }
      textToSpin.split("").forEach(element => {
        dummy = dummy + "0";
      });
      if (textToSpin.length >= 10) {
        return dummy;
      } else {
        let numOnEachSide = Math.floor((10 - textToSpin.length) / 2);
        dummy = dummy.padStart(numOnEachSide * 2 + dummy.length, "0");
        return dummy;
      }
    },
    animateToValue() {
      var textToSpin = "";
      if (this.eventSettings.spinningField === "name") {
        textToSpin = `${this.selected_attendee.firstname} ${
          this.selected_attendee.lastname
        }`;
      } else {
        textToSpin = `${
          this.selected_attendee[this.eventSettings.spinningField]
        }`;
      }
      if (textToSpin.length >= 10) {
        return textToSpin;
      }
      let numOnEachSide = Math.floor((10 - textToSpin.length) / 2);

      let str = textToSpin;
      let padLeft = str.padStart(numOnEachSide + str.length, " ");

      let finalValue = padLeft.padEnd(numOnEachSide + padLeft.length, " ");

      return finalValue;
    },
    animateSpin() {
      odoo.odoo.default({
        el: ".animated-text",
        from: this.dummySpinText(),
        to: this.animateToValue(),
        lineHeight: 1.35,
        letterSpacing: 1,
        animationDelay: 100,
        letterAnimationDelay: 100
      });

      var nas_mp3 = document.getElementById("myAudio");
      nas_mp3.loop = true;
      nas_mp3.load();
      nas_mp3.play();
    },
    startSpin() {
      this.state = "spinning";
      axios
        .post(
          window.ENDPOINT,
          {
            query: `
                            mutation {
                                createDraw(prizeId:"${this.prizeInfo.id}") {
                                    id
                                    position
                                    selectedAttendee
                                    status
                                }
                            }
                        `
          },
          {
            headers: {
              Authorization: localStorage.getItem("gevme_token")
            }
          }
        )
        .then(
          function(response) {
            if (response.data.errors) {
              if (response.data.errors[0].message == "No more attendees") {
                $("#finishModal").modal("show");
              }
            } else {
              this.state = "result";
              Object.assign(
                this.selected_attendee,
                response.data.data.createDraw.selectedAttendee
              );

              this.animateSpin();
            }
          }.bind(this)
        );
    },
    confirmWinner() {
      axios
        .post(
          window.ENDPOINT,
          {
            query: `
                            mutation {
                                updateDraw(status: "accept", prizeId:"${
                                  this.prizeInfo.id
                                }")
                            }
                        `
          },
          {
            headers: {
              Authorization: localStorage.getItem("gevme_token")
            }
          }
        )
        .then(
          function(response) {
            if (response.data.data.updateDraw.status == "accept") {
              if (this.current_winner < this.total_winners) {
                setTimeout(() => {
                  this.current_winner++;
                  this.state = "spin";
                }, 500);
              } else {
                this.confirmDrawSummary();
              }
            }
          }.bind(this)
        );
    },
    confirmDrawSummary() {
      axios
        .post(
          window.ENDPOINT,
          {
            query: `
                mutation {
                    updateDraw(status: "confirm", prizeId:"${
                      this.prizeInfo.id
                    }")
                }
            `
          },
          {
            headers: {
              Authorization: localStorage.getItem("gevme_token")
            }
          }
        )
        .then(
          function(response) {
            if (response.data.data.updateDraw.drawn) {
              // this.$router.push("/");
              this.$router.push({
                name: "Thankyou",
                params: {
                  images: {
                    background: this.eventSettings.backgroundUrl,
                    thankyou: this.eventSettings.thankyouImageUrl
                  }
                }
              });
            }
          }.bind(this)
        );
    },
    cancelDraw() {
      $("#finishModal").modal("hide");
      axios
        .post(
          window.ENDPOINT,
          {
            query: `
                    mutation {
                        updateDraw(status: "cancel", prizeId:"${
                          this.prizeInfo.id
                        }")
                    }
                `
          },
          {
            headers: {
              Authorization: localStorage.getItem("gevme_token")
            }
          }
        )
        .then(
          function(response) {
            this.$router.push({
              name: "Thankyou",
              params: {
                images: {
                  background: this.eventSettings.backgroundUrl,
                  thankyou: this.eventSettings.thankyouImageUrl
                }
              }
            });
          }.bind(this)
        );
    },
    confirmDrawSummary() {
      axios
        .post(
          window.ENDPOINT,
          {
            query: `
                mutation {
                    updateDraw(status: "confirm", prizeId:"${
                      this.prizeInfo.id
                    }")
                }
            `
          },
          {
            headers: {
              Authorization: localStorage.getItem("gevme_token")
            }
          }
        )
        .then(
          function(response) {
            if (response.data.data.updateDraw.drawn) {
              this.$router.push({
                name: "Thankyou",
                params: {
                  images: {
                    background: this.eventSettings.backgroundUrl,
                    thankyou: this.eventSettings.thankyouImageUrl
                  }
                }
              });
            }
          }.bind(this)
        );
    },
    finishDraw() {
      $("#finishModal").modal("hide");
      this.confirmDrawSummary();
    },
    performPrimaryAction() {
      switch (this.state) {
        case "spin":
          this.startSpin();
          break;
        case "respin":
          this.state = "spinning";
          axios
            .post(
              window.ENDPOINT,
              {
                query: `
                            mutation {
                                createDraw(prizeId:"${this.reSpinData.prizeId}",
                                    drawIdOfPosition: "${
                                      this.reSpinData.drawIdOfPosition
                                    }"
                                ) {
                                    id
                                    position
                                    selectedAttendee
                                    status
                                }
                            }
                        `
              },
              {
                headers: {
                  Authorization: localStorage.getItem("gevme_token")
                }
              }
            )
            .then(
              function(response) {
                if (response.data.errors) {
                  if (response.data.errors[0].message == "No more attendees") {
                    // $("#finishModal").modal("show");
                  }
                } else {
                  this.state = "result";
                  Object.assign(
                    this.selected_attendee,
                    response.data.data.createDraw.selectedAttendee
                  );
                }
              }.bind(this)
            );
          break;
        case "result":
          $(".btn.draw-action").attr("disabled", "disabled");
          if (
            this.current_winner < this.total_winners &&
            this.reSpinData == undefined
          ) {
            axios
              .post(
                window.ENDPOINT,
                {
                  query: `
                            mutation {
                                updateDraw(status: "accept", prizeId:"${
                                  this.prizeInfo.id
                                }")
                            }
                        `
                },
                {
                  headers: {
                    Authorization: localStorage.getItem("gevme_token")
                  }
                }
              )
              .then(
                function(response) {
                  $(".btn.draw-action").removeAttr("disabled");
                  if (response.data.data.updateDraw.status == "accept") {
                    this.winner_animate = true;
                    this.btn_default_color = "transparent";
                    this.btn_primary_color = "transparent";
                    setTimeout(() => {
                      this.current_winner++;
                      this.winner_animate = false;
                      this.btn_default_color = "buttonText";
                      this.btn_primary_color = "#fff";
                      this.state = "spin";
                    }, 500);
                  }
                }.bind(this)
              );
          } else {
            axios
              .post(
                window.ENDPOINT,
                {
                  query: `
                            mutation {
                                updateDraw(status: "accept", prizeId:"${
                                  this.prizeInfo.id
                                }")
                            }
                        `
                },
                {
                  headers: {
                    Authorization: localStorage.getItem("gevme_token")
                  }
                }
              )
              .then(
                function(response) {
                  $(".btn.draw-action").removeAttr("disabled");
                  if (response.data.data.updateDraw.status == "accept") {
                    this.confirmDrawSummary();
                  }
                }.bind(this)
              );
          }
          break;
        default:
          break;
      }
    },
    performSecondaryAction(param) {
      switch (param) {
        case "skip":
          $(".btn.draw-action").attr("disabled", "disabled");
          this.createLoading = true;
          if (this.reSpinData == undefined) {
            axios
              .post(
                window.ENDPOINT,
                {
                  query: `
                        mutation {
                            updateDraw(status: "skip", prizeId:"${
                              this.prizeInfo.id
                            }")
                        }
                    `
                },
                {
                  headers: {
                    Authorization: localStorage.getItem("gevme_token")
                  }
                }
              )
              .then(
                function(response) {
                  $(".btn.draw-action").removeAttr("disabled");
                  if (response.data.data.updateDraw.status === "skip") {
                    this.createLoading = false;
                    if (this.current_winner < this.total_winners)
                      this.current_winner++;
                    else {
                      this.confirmDrawSummary();
                    }
                  }
                }.bind(this)
              );
          } else {
            $(".btn.draw-action").removeAttr("disabled");
            this.confirmDrawSummary();
          }
          break;

        case "respin":
          this.respin = true;
          this.rejectAction();
          break;

        case "moveon":
          this.respin = false;
          this.rejectAction();
          break;

        default:
          break;
      }
    },
    rejectAction() {
      switch (this.respin) {
        case true:
          axios
            .post(
              window.ENDPOINT,
              {
                query: `
                            mutation {
                                updateDraw(status: "respin",
                                reason: "${this.rejectReason}",
                                prizeId:"${this.prizeInfo.id}")
                            }
                        `
              },
              {
                headers: {
                  Authorization: localStorage.getItem("gevme_token")
                }
              }
            )
            .then(
              function(response) {
                if (response.data.data.updateDraw.status == "respin") {
                  // $("#rejectModal").modal("hide");
                  this.rejectReason = "";
                  this.state = "spin";
                  this.performPrimaryAction();
                }
              }.bind(this)
            );
          break;

        case false:
          axios
            .post(
              window.ENDPOINT,
              {
                query: `
                            mutation {
                                updateDraw(status: "move",
                                reason: "${this.rejectReason}",
                                prizeId:"${this.prizeInfo.id}")
                            }
                        `
              },
              {
                headers: {
                  Authorization: localStorage.getItem("gevme_token")
                }
              }
            )
            .then(
              function(response) {
                if (response.data.data.updateDraw.status == "move") {
                  // $("#rejectModal").modal("hide");
                  this.rejectReason = "";
                  if (this.reSpinData == undefined) {
                    if (this.current_winner < this.total_winners) {
                      this.current_winner++;
                      this.state = "spin";
                    } else {
                      this.confirmDrawSummary();
                      // this.$router.push({
                      //   name: "DrawSummary",
                      //   params: {
                      //     prizeInfo: this.prizeInfo
                      //   }
                      // });
                    }
                  } else {
                    this.confirmDrawSummary();
                    // this.$router.push({
                    //   name: "DrawSummary",
                    //   params: {
                    //     prizeInfo: this.prizeInfo
                    //   }
                    // });
                  }
                }
              }.bind(this)
            );
          break;

        default:
          break;
      }
    }
  }
};
</script>

<style scoped>
.animated-spinner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  height: 100vh;
  padding-top: 150px;
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 100vh;
  overflow-y: scroll;
}
.spin-action {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.animated-spinner {
  padding: 25px;
  border-radius: 12px;
  text-align: center;
  background-image: linear-gradient(to bottom, #c80d18, #aa060f 42%, #63040c);
  min-width: 700px;
  position: relative;
}

.lights {
  position: absolute;
}

.lights.horizontal.top {
  top: 0px;
  left: 0px;
  width: 100%;
}

.lights.horizontal.bottom {
  bottom: 2px;
  left: 0px;
  width: 100%;
}

.lights.horizontal > img {
  height: 15px;
}

.action-btn-container {
  margin-top: 50px;
  margin-bottom: 50px;
}

.dropdown-toggle {
  background: transparent;
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
  position: relative;
}

.dropdown-toggle::after {
  display: none;
}

.btn-primary.spin {
  min-width: 150px;
  font-size: 14px;
  font-weight: 600;
  background-color: #0088ff;
}

.btn-default.spin {
  min-width: 150px;
  font-size: 14px;
  font-weight: 600;
  position: relative;
}

.lights.vertical {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.lights.vertical.left {
  left: 7px;
  height: 100%;
  top: 0;
}
.lights.vertical.right {
  right: 7px;
  height: 100%;
  top: 0;
}

.animated-spinner .text-container {
  display: flex;
  justify-content: center;
  min-height: 143px;
  border-radius: 15px;
  padding: 10px 30px;
  background-image: linear-gradient(
    to bottom,
    #959595,
    #999999 1%,
    #bbbbbb 7%,
    #d6d6d6 13%,
    #e9e9e9 19%,
    #f4f4f4 25%,
    #f8f8f8 32%,
    #f4f4f4 40%,
    #e9e9e9 47%,
    #d5d5d5 55%,
    #bababa 63%,
    #989898 70%,
    #959595 70%,
    #b2b2b2 81%,
    #777777
  );
}

.text-container .dummy {
  font-family: "Inconsolata";
  min-height: 82px;

  font-weight: bold;
  color: #171717;
  display: flex;
  align-items: center;
  position: relative;
  bottom: 10px;
  letter-spacing: 2px;
}

.text-container .dummy.transparent {
  color: transparent;
}

.text-container .animated-text {
  font-family: "Inconsolata";
  min-height: 82px;

  font-weight: bold;
  color: #171717;
  position: relative;
  top: 12px;
}

.reject-options > .dropdown-item {
  font-size: 14px;
  color: #5e6977;
  cursor: pointer;
}

.reject-options {
  position: absolute;
  left: -50px;
  top: 35px;
  box-shadow: 2px 4px 6px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px #e1e8ee;
  background-color: #fff;
  padding: 5px 0;
  border-radius: 4px;
}

.reject-options:before {
  position: absolute;
  top: -8px;
  right: 35px;
  display: inline-block;
  border-right: 8px solid transparent;
  border-bottom: 8px solid #ccc;
  border-left: 8px solid transparent;
  border-bottom-color: #dce3e8;
  content: "";
}

.reject-options:after {
  position: absolute;
  top: -7px;
  right: 36px;
  display: inline-block;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #ffffff;
  border-left: 7px solid transparent;
  content: "";
}

.prize-name {
  font-size: 60px;
  font-weight: bold;
  letter-spacing: 0.8px;
  color: #ffffff;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  margin-bottom: 25px;
  text-align: center;
}
h4.winner-indicator {
  font-size: 38px;
  font-weight: bold;
  letter-spacing: 0.5px;
  color: #ffffff;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  margin-bottom: 70px;
}

.modal-dialog {
  margin: 10rem auto;
  max-width: 670px;
}
.modal-body {
  padding: 45px;
}

.modal-body .title {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.modal-body .title h2 {
  font-size: 30px;
  font-weight: 600;
  margin-bottom: 35px;
}

.modal-btn-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 35px;
}
@media screen and (max-width: 699px) {
  .animated-spinner {
    min-width: 100vw;
  }
}

@media screen and (max-width: 768px) {
  .text-container .animated-text {
    top: 36px;
  }
  .prize-name {
    font-size: 30px;
  }
  h4.winner-indicator {
    font-size: 20px;
  }
}

@media screen and (min-width: 769px) {
  .text-container .dummy,
  .text-container .animated-text {
    font-size: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AnimatedSpin.vue